import React from 'react';
import {Skeleton, Spin} from "antd";

interface LoadingProps {
    spinning?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ spinning = true }) => {
    return (
        <Spin spinning={spinning} className="w-full h-full">
            <Skeleton/>
            <Skeleton/>
        </Spin>
    )
};

export default Loading;
